// @flow

import { put, call, all, takeEvery } from "redux-saga/effects";
import type { Action } from "redux-action";

import http from "@http";
import { sendSuccessMessage } from "@modules/app/actionCreator";
import * as actions from "@modules/service/constants/actions";
import actionCreators from "@modules/service/actionCreator";
import type { EmployeeSmsSettings } from "@modules/service/reducer/employee-sms-notifications/types";

type GetEmployeeSmsSettingsRequest = $Exact<{
  clientId: string,
}>;

export function* onGetEmployeeSmsSettings({
  payload,
}: Action<GetEmployeeSmsSettingsRequest>): Generator<*, void, { data: EmployeeSmsSettings }> {
  try {
    if (!payload || !payload.clientId) {
      throw Error("Invalid payload provided");
    }

    const respone = yield call(
      http.get,
      `/api/v2/service-admin/client/${payload.clientId}/service-config/absence-management/employee-sms-notifications`,
    );

    yield put(actionCreators.GetEmployeeSmsSettingsSuccess(respone.data));
  } catch (e) {
    yield put(actionCreators.GetEmployeeSmsSettingsError(e.response));
  }
}

type UpdateEmployeeSmsSettingsRequest = $Exact<{
  clientId: string,
  settings: EmployeeSmsSettings,
}>;

export function* onUpdateEmployeeSmsSettings({
  payload,
}: Action<UpdateEmployeeSmsSettingsRequest>): Generator<*, void, { data: EmployeeSmsSettings }> {
  try {
    if (!payload || !payload.clientId || !payload.settings) {
      throw Error("Invalid payload provided");
    }

    const response = yield call(
      http.put,
      `/api/v2/service-admin/client/${payload.clientId}/service-config/absence-management/employee-sms-notifications`,
      payload.settings,
    );

    yield all([
      put(actionCreators.UpdateEmployeeSmsSettingsSuccess(response.data)),
      put(actionCreators.GetEmployeeSmsSettings({ clientId: payload.clientId })),
      put(sendSuccessMessage("EMPLOYEE_SMS_SETTINGS_UPDATED")),
    ]);
  } catch (e) {
    yield put(actionCreators.UpdateEmployeeSmsSettingsError(e.response));
  }
}

// ROOT

export function* EmployeeSmsSettingsSagas(): Generator<*, void, void> {
  yield all([
    takeEvery(actions.GetEmployeeSmsSettings, onGetEmployeeSmsSettings),
    takeEvery(actions.UpdateEmployeeSmsSettings, onUpdateEmployeeSmsSettings),
  ]);
}

export default EmployeeSmsSettingsSagas;
